export default __webpack_public_path__ + "static/media/loading.5670cac6.gif";